module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card card-inverse",
    staticStyle: {
      "width": "30rem",
      "background-color": "#333",
      "border-color": "#333"
    }
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.movies.Poster,
      "alt": "img.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.movies.Title))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.movies.Plot))])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "list-group-item-text"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.movies.Ratings), function(rating) {
    return _c('li', {
      key: rating,
      staticClass: "list-group-item list-group-item-info"
    }, [(rating.Source == 'Internet Movie Database') ? _c('span', {
      staticClass: "label label-default label-pill"
    }, [_c('icon', {
      staticStyle: {
        "margin-right": ".5rem"
      },
      attrs: {
        "name": "imdb",
        "color": "black",
        "scale": "3"
      }
    })], 1) : _vm._e(), _vm._v(" " + _vm._s(rating.Source) + ": " + _vm._s(rating.Value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "btn text-left",
    staticStyle: {
      "padding": "0",
      "margin": ".25rem .25rem 0 .25rem",
      "width": "4rem",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-circle",
      "color": "red",
      "scale": "1.5"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row card-group",
    staticStyle: {
      "cursor": "pointer"
    }
  }, _vm._l((_vm.home), function(res) {
    return _c('div', {
      key: res,
      staticClass: "col-sm-3 card",
      staticStyle: {
        "font-family": "'Source Sans Pro'"
      },
      on: {
        "mousedown": function($event) {
          _vm.title = res.title
        },
        "mouseup": _vm.result
      }
    }, [_c('img', {
      staticClass: "card-img-top",
      staticStyle: {
        "width": "200px",
        "height": "250px"
      },
      attrs: {
        "src": _vm.imgUrl + res.poster_path
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h3', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(res.title))]), _vm._v(" "), _c('p', {
      staticClass: "card-text"
    }, [_vm._v(_vm._s(res.overview))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfb29bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Theater.vue
// module id = 834
// module chunks = 0